// extracted by mini-css-extract-plugin
export default {"font-monospaced-num":"styles_font-monospaced-num__q0gWI"};